import React, { useState } from "react";
import "./ourTeam.css";
import staff from "../../Common/team.json";
import { SiLinkedin } from "react-icons/si";
import { AiOutlineCloseCircle } from "react-icons/ai";

const OurTeam = (props) => {
  const t = props.language;
  const equipe = staff.team;
  const [staffObj, setStaffObj] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
  });
  return (
    <div className="team" id="team">
      <div className="team__div">
        <div className="text__team">
          {t("team")}
          <span className="line__team"></span>
        </div>
        <div className="team__desc--wrap">
          <p className="team__desc" style={{ marginTop: "1rem" }}>
            {t("team_desc")}
          </p>
        </div>
      </div>
      <div className="team__container" style={{ marginTop: "2rem" }}>
        {equipe.map((membre, index) => {
          return (
            <>
              {staffObj[index + 1] ? (
                <div
                  className="overlay__team"
                  onClick={() => {
                    setStaffObj({
                      1: false,
                      2: false,
                      3: false,
                      4: false,
                      5: false,
                      6: false,
                      7: false,
                      8: false,
                      9: false,
                      10: false,
                    });
                  }}
                >
                  <div className="overlay__information">
                    <div className="overlay__information--left">
                      <img
                        className="overlay__member-card"
                        // src={require(`../../Assets/${membre.lastName}.png`)}
                        src={require(`../../Assets/Staff/${membre.firstName}.jpg`)}
                        alt="img"
                      ></img>
                    </div>
                    <div className="overlay__information--right">
                      <h3 className="overlay__firstname">
                        {membre.firstName} {membre.lastName.toUpperCase()}
                      </h3>
                      <div className="overlay__role">
                        {membre[`role_${t("isEN")}`]}
                        <a className="animation-none" href={`${membre.link}`}>
                          <SiLinkedin className="linkedin" />
                        </a>
                      </div>
                      <p className="overlay__background-xp">
                        {membre[`background_${t("isEN")}`]}
                      </p>
                    </div>
                    <div className="overlay__close">
                      <AiOutlineCloseCircle className="close__btn" />
                    </div>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
              <div
                className="member-wrap"
                key={index}
                onClick={() => {
                  setStaffObj({
                    [index + 1]: !staffObj[index + 1],
                  });
                }}
              >
                <div className="image--bg">
                  {membre.test ? (
                    <img
                      className="member-card"
                      // src={require(`../../Assets/${membre.lastName}.png`)}
                      src={require(`../../Assets/Staff/${membre.firstName}.jpg`)}
                      // src={require(`../../Assets/test2.jpg`)}
                      alt="img"
                    ></img>
                  ) : (
                    <img></img>
                  )}
                  <div className="name-lnk">
                    <h3 className="firstname">
                      {membre.firstName} {membre.lastName.toUpperCase()}
                    </h3>
                    <p className="role">{membre[`role_${t("isEN")}`]}</p>
                    <p className="unkown">{membre.unknown}</p>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default OurTeam;
